import {getCookieValue} from 'swayok-react-mdb-ui-kit/helpers/getCookieValue'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {WebPushService} from 'swayok-react-mdb-ui-kit/services/WebPushService'
import {WebSocketService} from 'swayok-react-mdb-ui-kit/services/WebSocketService'
// Задаем функцию, которая будет шифровать id объявления для запроса на получение номера телефона.
import './helpers/getAnalyticsToken'
import {AppConfig} from './AppConfig'
import {AnalyticsEventReporter} from './helpers/AnalyticsEventReporter'
import {AnalyticsService} from './services/AnalyticsService'
import {PwaInstallService} from './services/PwaInstallService'

// Настройка сервиса навигации по страницам.
NavigationService.configure({
    rootUrl: AppConfig.rootUrl,
    baseUrl: AppConfig.baseUrl,
    baseApiUrl: AppConfig.baseApiUrl,
})

// Настройка сервиса запросов к API.
ApiRequestService.configure({
    baseApiUrl: AppConfig.baseApiUrl,
    getTimeout: AppConfig.apiGetRequestTimeout,
    postTimeout: AppConfig.apiPostRequestTimeout,
    allowRequestsLogs: !AppConfig.isProduction,
    notLoggableRequests: [
        '/v1/user/flags',
        '/v1/user',
    ],
    beforeSend(headers: Headers) {
        headers.set('X-XSRF-TOKEN', getCookieValue('XSRF-TOKEN') ?? '')
    },
    onException: AnalyticsEventReporter.apiRequestError,
})

// Настройка сервиса Web PUSH уведомлений.
WebPushService.configure(AppConfig.webPushConfig)

// Начинаем слушать событие готовности к установке приложения (для кнопки "Установить приложение").
PwaInstallService.init()

// Регистрация service worker для PWA (offline режим) независимо от подписки на PUSH уведомления.
// Повторная регистрация этого же скрипта в WebPushService вернет ту же регистрацию.
// В dev режиме не регистрируем, чтобы устаревший service worker не мешал HMR и отладке.
if ('serviceWorker' in navigator) {
    const registerServiceWorker = () => {
        navigator.serviceWorker
            .register(AppConfig.webPushConfig.serviceWorkerScriptUrl ?? '/service-worker.js')
            .catch((error: unknown) => {
                console.error('[ServiceWorker] Registration error: ', error)
            })
    }
    // Регистрация после загрузки страницы, чтобы не конкурировать с загрузкой самого приложения.
    if (document.readyState === 'complete') {
        registerServiceWorker()
    } else {
        window.addEventListener('load', registerServiceWorker, {once: true})
    }
}

// Настройка сервиса обработки событий, получаемых через web socket.
WebSocketService.configure(AppConfig.laravelEcho)

// Объявляем Pusher глобально доступным (зачем-то это нужно делать явно).
void import('pusher-js')
    .then(pusher => {
        {
            window.Pusher = pusher.default
        }
    })

/*
const suppressExceptionsByMessage: RegExp[] = [
    // Мусорные ошибки xbrowser / swbrowser is not defined.
    /([a-zA-Z0-9]+browser) is not defined/i,
    // Мусорные ошибки плагинов или сторонних скриптов.
    /^(A) is not defined/i,
    /^Can't find variable: (A)$/i,
    // zaloJSV2 is not defined / Can't find variable: zaloJSV2.
    /zaloJSV2/,
    // Ошибка загрузки чанка происходит при пересборке приложения.
    // Пока сборка не переделана на бесшовный deploy, от них не избавиться никак.
    /Loading chunk \d+ failed/i,
    // ResizeObserver loop completed with undelivered notifications.
    // Часто не относится к самому приложению.
    /ResizeObserver loop completed/i,
    // Ошибка где-то вне приложения.
    // Полезной нагрузки эти ошибки не несут, поэтому их можно игнорировать.
    /^Script error\.$/i,
    // Ошибка внутри Clarity.
    /t\.replace is not a function. \(In 't\.replace\(o,e\)', 't\.replace' is undefined\)/i,
]
*/

AnalyticsService.initGlobals(AppConfig.analyticsConfig)

// Отправляем AppConfig.trackingConfig.trackingId в сервисы сбора аналитики.
AnalyticsEventReporter.sendTrackingIdToAnalytics()
